"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import SectionHeading from "../shared/SectionHeading";
import "swiper/swiper-bundle.css";

const CourseOffers = ({ data }) => {
  const IMAGE_BASE = process.env.REACT_APP_IMAGE_URL;

  if (!data.section[2].isActive) {
    return <div></div>;
  }

  return (
    <div className="mt-12 px-12 sm:px-[90px] mx-auto max-w-[1500px]">
      <SectionHeading>
        <span className="text-primary-color">What does this</span>{" "}
        <span className="text-secondary-color">Course Offer</span>
      </SectionHeading>
      <div className="mt-8">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={6} // Reduced spacing for desktop
          slidesPerView={1} // Full-width slides on mobile
          breakpoints={{
            640: { slidesPerView: 1.2, spaceBetween: 10 }, // Tablets
            768: { slidesPerView: 2, spaceBetween: 14 }, // Medium screens
            1024: { slidesPerView: 3, spaceBetween: 18 }, // Larger screens
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true, dynamicBullets: true }}
          className="py-8"
        >
          {data.section[2].body.list1.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="max-w-[95%] sm:max-w-[300px] h-[320px] mx-auto bg-gradient-to-br from-[#f7fafc] to-[#e3e9f7] border border-[#e0e7ff] rounded-2xl flex flex-col justify-start text-center overflow-hidden shadow-none transition-all duration-200 hover:scale-[1.035] hover:shadow-lg p-3 sm:p-5">
                <div className="flex flex-col items-center">
                  <img
                    src={`${IMAGE_BASE}/${item.image}`}
                    alt={item.title}
                    className="w-full h-[110px] sm:h-[130px] object-cover rounded-lg mb-2 sm:mb-3 shadow-sm"
                  />
                </div>
                <h1 className="text-[17px] font-bold text-[#1a237e] mt-2 mb-1 leading-tight truncate" title={item.title}>
                  {item.title}
                </h1>
                <p className="mt-1 text-[14px] text-[#262626] leading-relaxed line-clamp-4">
                  {item.text}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="mb-8" />
    </div>
  );
};

export default CourseOffers;
